import React from 'react';

import CustomRadioInput from 'components/partials/custom-radio-input/custom-radio-input';

import { RADIO_OPTIONS } from 'containers/admin/clients/client/tabs-components/critical-elements/critical-elements-manager/critical-element/related-goals/related-goals.const';

const RelatedGoalsFilters = ({
  filterOption,
  handleFilterChange,
  isCreation,
}) => (
  <div className="flex gap-x-5">
    <div className="font-semibold text-gray-04">Show</div>
    <div className="flex">
      {RADIO_OPTIONS.map((option) => (
        <CustomRadioInput
          key={option.value}
          labelFor={option.value}
          label={option.label}
          radioValue={option.value}
          setAction={handleFilterChange}
          onChange={handleFilterChange}
          value={filterOption}
          customClass="mr-4"
          labelClass={option.colorClass}
          disabled={option.value === 'linked' && isCreation}
        />
      ))}
    </div>
  </div>
);

export default RelatedGoalsFilters;
